import { ProductTypeEnum } from "@shared/enums";
import { ProductListingConfigurationError } from "../abProducts.config";

export interface CameraFilterConfig {
  enabled: boolean;
  brands?: readonly string[];
  types: readonly (ProductTypeEnum.REFLEX | ProductTypeEnum.MIRRORLESS)[];
}

const parseStringArray = (value: string | null, name: string): string[] | undefined => {
  if (value === null) return undefined;
  let parsed: unknown;
  try { parsed = JSON.parse(value); }
  catch { throw new ProductListingConfigurationError(`${name} must be a JSON array.`); }
  if (!Array.isArray(parsed) || !parsed.length || !parsed.every((item) => typeof item === "string" && item.length > 0)
    || new Set(parsed).size !== parsed.length) {
    throw new ProductListingConfigurationError(`${name} must contain unique non-empty strings.`);
  }
  return parsed;
};

export const readCameraFilterConfig = (element: Pick<Element, "hasAttribute" | "getAttribute">): CameraFilterConfig => {
  const enabled = element.hasAttribute("camera-enabled");
  const brands = parseStringArray(element.getAttribute("camera-brands"), "camera-brands");
  const types = parseStringArray(element.getAttribute("camera-types"), "camera-types")
    ?? [ProductTypeEnum.REFLEX, ProductTypeEnum.MIRRORLESS];
  if (types.some((type) => type !== ProductTypeEnum.REFLEX && type !== ProductTypeEnum.MIRRORLESS)) {
    throw new ProductListingConfigurationError("camera-types accepts only reflex and mirrorless.");
  }
  return { enabled, brands, types: types as CameraFilterConfig["types"] };
};
